import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIlevel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6702 12.0736H5.53736C5.22538 12.0736 4.96667 11.8106 4.96667 11.4936C4.96667 11.1765 5.22538 10.9136 5.53736 10.9136H11.6702C11.9822 10.9136 12.2409 11.1765 12.2409 11.4936C12.2409 11.8106 11.9822 12.0736 11.6702 12.0736Z",
			fill: "url(#paint0_linear_1376_5488)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.6702 20.3175H5.53736C5.22538 20.3175 4.96667 20.0545 4.96667 19.7375C4.96667 19.4204 5.22538 19.1575 5.53736 19.1575H11.6702C11.9822 19.1575 12.2409 19.4204 12.2409 19.7375C12.2409 20.0545 11.9822 20.3175 11.6702 20.3175Z",
			fill: "url(#paint1_linear_1376_5488)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0779 16.1956H4.80481C4.49284 16.1956 4.23413 15.9327 4.23413 15.6156C4.23413 15.2986 4.49284 15.0356 4.80481 15.0356H10.0779C10.3898 15.0356 10.6485 15.2986 10.6485 15.6156C10.6485 15.9327 10.3974 16.1956 10.0779 16.1956Z",
			fill: "url(#paint2_linear_1376_5488)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.20293 7.9515H8.36602C8.05409 7.9515 7.79541 7.68857 7.79541 7.3715C7.79541 7.05444 8.05409 6.7915 8.36602 6.7915H9.20293C9.51486 6.7915 9.77353 7.05444 9.77353 7.3715C9.77353 7.68857 9.51486 7.9515 9.20293 7.9515Z",
			fill: "#D80A33"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.20293 24.4395H8.36602C8.05409 24.4395 7.79541 24.1766 7.79541 23.8595C7.79541 23.5425 8.05409 23.2795 8.36602 23.2795H9.20293C9.51486 23.2795 9.77353 23.5425 9.77353 23.8595C9.77353 24.1766 9.51486 24.4395 9.20293 24.4395Z",
			fill: "#E14160"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.91543 7.51121L11.5938 11.2696C10.3992 12.36 9.69155 13.9222 9.69155 15.5926C9.69155 17.263 10.3992 18.8328 11.5938 19.9155L8.91543 23.6739C6.53381 21.7096 5.14135 18.7632 5.14135 15.6003C5.14135 12.4374 6.53381 9.49094 8.91543 7.51121ZM9.16653 5.88721C6.05444 7.95974 4 11.5403 4 15.6003C4 19.6603 6.05444 23.2408 9.16653 25.3134L13.1917 19.668C11.784 18.8792 10.8329 17.3558 10.8329 15.6003C10.8329 13.8526 11.784 12.3291 13.1917 11.5326L9.16653 5.88721Z",
			fill: "url(#paint3_linear_1376_5488)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8168 4C13.9602 4 12.2025 4.45628 10.6503 5.26054L14.7972 11.076C15.1243 10.9986 15.4667 10.96 15.8168 10.96C18.3278 10.96 20.367 13.0402 20.367 15.6C20.367 18.1597 18.3278 20.24 15.8168 20.24C15.4667 20.24 15.1243 20.2013 14.7972 20.124L10.6503 25.9394C12.2025 26.7437 13.9526 27.2 15.8168 27.2C22.1018 27.2 27.1999 22.0032 27.1999 15.6C27.1999 9.1968 22.1018 4 15.8168 4Z",
			fill: "url(#paint4_linear_1376_5488)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_1376_5488",
				x1: 5.68003,
				y1: 12.0678,
				x2: 26.4006,
				y2: 12.0678,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D80831" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DC2347"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_1376_5488",
				x1: 5.40003,
				y1: 9.5854,
				x2: 25.7737,
				y2: 23.957,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#DC2347" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E13E5E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_1376_5488",
				x1: 5.05061,
				y1: 17.0693,
				x2: 21.3283,
				y2: 24.5202,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D91037" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#DE2B4E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_1376_5488",
				x1: 11.0491,
				y1: 5.07076,
				x2: 24.7904,
				y2: 24.3443,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D6002A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E34D6A"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_1376_5488",
				x1: 15.6787,
				y1: 5.07076,
				x2: 30.214,
				y2: 19.614,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#D6002A" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#E34D6A"
				})]
			})
		] })
	]
});
export default SvgIlevel;
